import styled from "@emotion/styled";
import { CheckBoxEmpty, CheckBoxFull } from "../../assets/icons/icons";
import { MemberDetail } from "../../types/types";
import theme from "../../theme";
import { useI18n } from "../../locales";

const { sm, md, lg } = theme.screen;

const AuthField: React.FC<{ data?: MemberDetail }> = (props) => {
  const { data } = props;
  const { t } = useI18n();
  // console.log(data);

  return (
    <AuthWrapper>
      <FirstCol>
        <AuthHeader>{t.manageUser.detectionNotification}</AuthHeader>
        <CheckBoxWrapper>
          <SelectWrapper>
            <CheckBoxIconWrapper>
              {data?.permission?.auth_accident === "Y" ? (
                <CheckBoxFull />
              ) : (
                <CheckBoxEmpty />
              )}
            </CheckBoxIconWrapper>
            <SelectText>{t.manageUser.dangerAccident}</SelectText>
          </SelectWrapper>
          <SelectWrapper>
            <CheckBoxIconWrapper>
              {data?.permission?.auth_warning === "Y" ? (
                <CheckBoxFull />
              ) : (
                <CheckBoxEmpty />
              )}
            </CheckBoxIconWrapper>
            <SelectText>{t.manageUser.warningDangerousArea}</SelectText>
          </SelectWrapper>
          <SelectWrapper>
            <CheckBoxIconWrapper>
              {data?.permission?.auth_battery === "Y" ? (
                <CheckBoxFull />
              ) : (
                <CheckBoxEmpty />
              )}
            </CheckBoxIconWrapper>
            <SelectText>{t.manageUser.batteryAbnormal}</SelectText>
          </SelectWrapper>
          <SelectWrapper>
            <CheckBoxIconWrapper>
              {data?.permission?.auth_out === "Y" ? (
                <CheckBoxFull />
              ) : (
                <CheckBoxEmpty />
              )}
            </CheckBoxIconWrapper>
            <SelectText>{t.manageUser.areaExit}</SelectText>
          </SelectWrapper>
        </CheckBoxWrapper>
      </FirstCol>
      <SecondCol>
        <AuthHeader>{t.manageUser.functionManagement}</AuthHeader>
        <CheckBoxWrapper>
          <SelectWrapper>
            <CheckBoxIconWrapper>
              {data?.permission?.auth_check === "Y" ? (
                <CheckBoxFull />
              ) : (
                <CheckBoxEmpty />
              )}
            </CheckBoxIconWrapper>
            <SelectText>{t.manageUser.detectionRelease}</SelectText>
          </SelectWrapper>
          <SelectWrapper>
            <CheckBoxIconWrapper>
              {data?.permission?.auth_modify === "Y" ? (
                <CheckBoxFull />
              ) : (
                <CheckBoxEmpty />
              )}
            </CheckBoxIconWrapper>
            <SelectText>{t.manageUser.deviceInfoModify}</SelectText>
          </SelectWrapper>
        </CheckBoxWrapper>
      </SecondCol>
    </AuthWrapper>
  );
};

const AuthWrapper = styled.div`
  width: 1010px;
  padding-top: 20px;
  padding-bottom: 30px;
  padding-left: 30px;
  background: ${theme.color.neutral_50};
  display: flex;
  margin-bottom: 40px;
  border-radius: 10px;

  @media (max-width: ${sm}px) {
    padding: 10px;
  }

  @media (max-width: ${lg}px) {
    flex-direction: column;
    gap: 40px;
  }
`;

const FirstCol = styled.div`
  @media (min-width: ${lg + 1}px) {
    margin-right: 40px;
  }
`;

const SecondCol = styled.div`
  @media (min-width: ${lg + 1}px) {
    margin-right: 40px;
  }
`;

const AuthHeader = styled.p`
  font-weight: 400;
  font-size: 13px;
  line-height: 24px;
  color: ${theme.color.neutral_800};
  margin-bottom: 18px;
`;

const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 5px 10px;
`;

const SelectText = styled.span`
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  color: ${theme.color.neutral_600};
`;

const CheckBoxIconWrapper = styled.div`
  transform: translateY(1px);
`;

const CheckBoxWrapper = styled.div`
  display: flex;
  gap: 13px;
  flex-wrap: wrap;

  @media (max-width: ${md}px) {
    flex-direction: column;
    padding: 10px;
    gap: 20px;
  }
  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    gap: 10px;
  }
`;

export default AuthField;
